import Loader from 'Common/Loader';
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { GetPurchaseOrderRequestList, GetOldGoldPurchaseOrderItemListByBagId, GenerateDeliveryChallan } from '../servises/OldGoldRequestService'
import PdfViewerModal from 'modules/return/return-to-mayave-request/components/PdfViewerModal';
import ActionOldGoldRequest from './ActionOldGoldRequest';

const OldGoldRequestData: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [permissionDetails, setPermissionDetails] = useState<string[]>([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [salesEntryDetails, setSalesEntryDetails] = useState<any>(null);
    const [pdfData, setPdfData] = useState<string | null>(null);
    const [selectedInvoice, setSelectedInvoice] = useState<any>(null);

    useEffect(() => {
        const authUserString = localStorage.getItem("authPOSUser");
        if (authUserString) {
            const authUser = JSON.parse(authUserString);
            const permissionData = authUser?.permissions || [];
            setPermissionDetails(permissionData);
        }
    }, []);

    const HasPermission = (permission: string): boolean => {
        return permissionDetails.includes(permission);
    };

    const handleView = async (data: any) => {
        setLoading(true);
        try {
            const response = await GetOldGoldPurchaseOrderItemListByBagId(data.id);
            if (response?.data) {
                setSalesEntryDetails(response.data);
                setSelectedInvoice(data);
                setShowDetailsModal(true);
            }
        } catch (error) {
            console.error("Error fetching sales entry details:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleViewPdf = async (data: any) => {
        if (!data) return;
        setSelectedInvoice(data);
        setLoading(true);
        try {
            const response = await GetOldGoldPurchaseOrderItemListByBagId(data.invoiceName);
            if (response?.data) {
                setPdfData(response.data);
                setShowPdfModal(true);
                setShowDetailsModal(false);
            }
        } catch (error) {
            console.error("Error fetching PDF:", error);
        } finally {
            setLoading(false);
        }
    };

    const dataSource = (): any | undefined => {
        return new CustomStore({
            load: async (loadOptions) => {
                try {
                    const { searchValue, skip, take } = loadOptions;
                    const parameterList = new URLSearchParams();
                    if (typeof skip === 'number') parameterList.append('skip', skip.toString());
                    if (typeof take === 'number') parameterList.append('take', take.toString());
                    const search = JSON.parse(JSON.stringify(loadOptions));
                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }
                    if (searchValue) {
                        parameterList.append("search", searchValue);
                    }
                    const response = await GetPurchaseOrderRequestList(parameterList);
                    return response;
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            }
        });
    }

    const reloadDataSource = () => {
        setRefreshKey(prev => prev + 1);
    };

    const formatCurrency = (amount: number) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(amount || 0);
    };

    return (
        <React.Fragment>
            {loading && <Loader />}

            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Old Gold Request</h5>
                        </Card.Header>
                        <Card.Body className='pt-0'>
                            {HasPermission("PurchaseOrder.Read") &&
                                <DataGrid
                                    dataSource={dataSource()}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    key={refreshKey}
                                    showBorders={true}
                                    columnAutoWidth={true}
                                    onCellPrepared={(e) => {
                                        if (['data', 'header'].includes(e.rowType)) {
                                            e.cellElement.style.textAlign = 'center';
                                        }
                                    }}

                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}
                                >
                                    <Pager
                                        showPageSizeSelector={true}
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />
                                    <Summary>
                                        <TotalItem
                                        // column="Sr.No."
                                        // summaryType="count"
                                        // displayFormat="Total : {0}"
                                        />
                                    </Summary>
                                    <Paging defaultPageSize={10} />
                                    <SearchPanel visible width={240} placeholder="Search..." />

                                    <Scrolling
                                        mode='standard'
                                        useNative={true}
                                        scrollByContent={true}
                                        scrollByThumb={true}
                                    />
                                    <Column
                                        dataField="action"
                                        caption="Action"
                                        allowFiltering={false}
                                        dataType="string"
                                        width={120}
                                        cellRender={({ data }) => (
                                            <>
                                                {HasPermission("PurchaseOrder.Write") &&
                                                    <ActionOldGoldRequest selectedId={data.bagId as string} reloadDataSource={reloadDataSource} status={String(data?.status)} />
                                                }
                                            </>
                                        )}
                                    />
                                    <Column
                                        dataField="id"
                                        dataType="number"
                                        sortOrder="desc"
                                        visible={false}
                                    />
                                    <Column dataField="voucherNo" caption="Voucher Number" dataType="string" />
                                    <Column
                                        dataField="date"
                                        caption="Date"
                                        dataType="string"
                                        allowFiltering={false}
                                        cellRender={({ data }) => moment(data.date).format('DD/MM/YYYY')}
                                    />
                                    <Column dataField="storeName" caption="Store Name" dataType="string" />
                                    <Column dataField="purchaseAmount" format="#,##0.00" caption="Total Purchase Amount" dataType="number" cssClass='text-center' />
                                    <Column dataField="status" caption="Status" dataType="string" />
                                    <Column dataField="clickPostStatus" caption="Click Post Status" />
                                    <Column dataField="lable" caption="Shipping Label"
                                        cellRender={(cellData) => {
                                            const url = cellData?.value;
                                            console.log(cellData.value, "cellData.value");
                                            if (url)
                                                return (
                                                    <a
                                                        href={url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        download
                                                        style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer" }}
                                                    >
                                                        View Shipping Label
                                                    </a>
                                                );
                                        }}
                                    />
                                </DataGrid>
                            }
                        </Card.Body>
                    </Card>
                </div>
            </div>



            {/* PDF Viewer Modal */}
            <PdfViewerModal
                visible={showPdfModal}
                base64Data={pdfData}
                onClose={() => {
                    setShowPdfModal(false);
                    setPdfData(null);
                }}
                title={`Invoice - ${selectedInvoice?.invoiceName}`}
            />
        </React.Fragment>
    );
};

export default OldGoldRequestData;
